import { Outlet, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../stores/authStore';

export default function AuthLayout() {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="w-12 h-12 border-4 rounded-full animate-spin border-primary-500 border-t-transparent" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen p-4 bg-linear-to-br from-primary-500 to-primary-700">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="mb-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 mb-4 bg-white shadow-lg rounded-2xl">
            <span className="text-3xl">🏠</span>
          </div>
          <h1 className="text-3xl font-bold text-white">FamilyHub</h1>
          <p className="mt-2 text-primary-100">
            {t('auth.tagline')}
          </p>
        </div>

        {/* Auth form container */}
        <div className="p-8 bg-white shadow-xl rounded-2xl">
          <Outlet />
        </div>

        {/* Footer */}
        <p className="mt-6 text-sm text-center text-primary-200">
          {t('auth.copyright')}
        </p>
      </div>
    </div>
  );
}
